var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("tbody", [
    _c(
      "tr",
      [
        _c(
          "td",
          { staticClass: "px-2 py-4 text-left" },
          [_c("StatusBadge", { attrs: { activity: _vm.activity } })],
          1
        ),
        _c("td", { staticClass: "table-cell w-min-content" }, [
          _c(
            "button",
            {
              staticClass: "notesLink flex justify-center items-center",
              on: { click: _vm.handleShow },
            },
            [_vm._v(" View Notes ")]
          ),
        ]),
        _c("td", { staticClass: "px-2 py-4 text-left" }, [
          _c(
            "div",
            [
              _vm.contractorExists
                ? _c(
                    "RouterLink",
                    { attrs: { to: _vm.contractor?.routeParams } },
                    [
                      _vm.activity.contractor && _vm.activity.contractor?.user
                        ? _c("div", [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-storm-gray text-sm p-1 font-medium rounded-full block border border-gray-300 bg-white borderCard hover:text-primary-500 hover:border-primary-500",
                              },
                              [
                                _vm.activity.contractor?.user
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-row items-center",
                                        attrs: {
                                          name: "imageAvatar",
                                          image:
                                            _vm.activity.contractor?.user
                                              .avatar,
                                        },
                                      },
                                      [
                                        _vm.activity.contractor?.user.avatar !==
                                        null
                                          ? _c("S3Image", {
                                              class: [_vm.defaultImageClasses],
                                              attrs: {
                                                s3FileKey:
                                                  _vm.activity.contractor?.user
                                                    .avatar,
                                              },
                                            })
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-xs font-medium text-white justify-center flex items-center rounded-full border border-gray-300 bg-white w-6 h-6 mr-2",
                                                class: _vm.getAvatrClass,
                                                style: _vm.bgStyle,
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.initial) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-storm-gray text-sm font-medium",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.activity.contractor?.user
                                                    .given_name
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.activity.contractor?.user
                                                    .family_name
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ])
                        : _c("div", [_vm._v("n/a")]),
                    ]
                  )
                : _vm._e(),
              !_vm.contractorExists && _vm.skillIds
                ? _c(
                    "div",
                    { staticClass: "activity-info" },
                    [
                      _c("SuitableResources", {
                        attrs: {
                          skillIds: _vm.skillIds,
                          limit: 0,
                          visitId: _vm.activity.id,
                          excludeResourceUserId: _vm.excludeResourceUserId,
                          companyId: _vm.companyId,
                          isMinHeight: "minHeight",
                        },
                        on: { fetchNewActivity: _vm.visitUpdated },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activity.drafted && !_vm.contractorExists && !_vm.skillIds
                ? _c(
                    "div",
                    { staticClass: "activity-info" },
                    [
                      _c(
                        "RouterLink",
                        { attrs: { to: _vm.resourceDirectory } },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-sm text-notification-blue leading-normal font-400",
                            },
                            [_vm._v(" Go to Talent Directory ")]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c("td", { staticClass: "px-2 py-4 text-left" }, [
          _c("div", { staticClass: "activity-info" }, [
            _vm._v(_vm._s(_vm.jobTitle)),
          ]),
        ]),
        _c("td", { staticClass: "px-2 py-4 text-left" }, [
          _c("tr", [
            _c("td", { staticClass: "activity-info" }, [
              _vm._v(
                " " + _vm._s(_vm.startTime) + " - " + _vm._s(_vm.endTime) + " "
              ),
            ]),
          ]),
          _c("tr", [
            _c("td", { staticClass: "activity-sub-info" }, [
              _vm._v(_vm._s(_vm.startDate)),
            ]),
          ]),
        ]),
        _c("td", { staticClass: "px-2 py-4 text-left" }, [
          _c("div", { staticClass: "activity-info" }, [
            _vm._v(_vm._s(_vm.typeOfVisit)),
          ]),
        ]),
        _c("td", { staticClass: "px-2 py-4 text-left" }, [
          _vm.location
            ? _c(
                "a",
                {
                  staticClass: "text-blue text-sm font-400 hover:underline",
                  attrs: {
                    href: _vm.googleMapsLink,
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.location) + " ")]
              )
            : _c("p", { staticClass: "text-blue text-sm font-400" }, [
                _vm._v("n/a"),
              ]),
        ]),
        _c("td", { staticClass: "px-2 py-4 text-left" }, [
          _c(
            "div",
            {
              staticClass: "text-sm font-400 leading-normal",
              class: _vm.checkInColor,
            },
            [_vm._v(" " + _vm._s(_vm.checkedInTime) + " ")]
          ),
        ]),
        _c("td", { staticClass: "px-2 py-4 text-left" }, [
          _c(
            "div",
            {
              staticClass: "text-sm font-400 leading-normal",
              class: _vm.checkOutColor,
            },
            [_vm._v(" " + _vm._s(_vm.checkedOutTime) + " ")]
          ),
        ]),
        _c("td", { staticClass: "px-2 py-4 text-left" }, [
          _vm.activity.project_activity_skills.length > 0
            ? _c(
                "div",
                { staticClass: "flex flex-row gap-1 items-center" },
                [
                  _vm._l(
                    _vm.activity.project_activity_skills.slice(0, 3),
                    function (skill) {
                      return _c(
                        "div",
                        { key: skill.id, staticClass: "skills-chip" },
                        [_vm._v(" " + _vm._s(skill.skill.name) + " ")]
                      )
                    }
                  ),
                  _vm.activity.project_activity_skills.length > 3
                    ? _c("div", [
                        _c("div", { staticClass: "skills-chip-plus" }, [
                          _vm._v(
                            " +" +
                              _vm._s(
                                _vm.activity.project_activity_skills.length - 3
                              ) +
                              " "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _c("p", { staticClass: "activity-info" }, [_vm._v("n/a")]),
        ]),
        !_vm.actionsHidden
          ? _c("td", { staticClass: "table-cell" }, [
              _vm.activity.completed && !_vm.activity.drafted
                ? _c("div")
                : !_vm.activity.completed && !_vm.activity.drafted
                ? _c(
                    "div",
                    { staticClass: "w-8" },
                    [
                      _c("MoreActions", {
                        staticClass: "relative",
                        attrs: { TooltipBoxStyle: "tooltipTasks" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "action-buttons",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "flex flex-col bg-white" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "actionLink",
                                          on: { click: _vm.onEdit },
                                        },
                                        [_vm._v("Edit Visit")]
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "actionLink",
                                          on: { click: _vm.completeActivity },
                                        },
                                        [_vm._v(" Mark as complete ")]
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "actionLink",
                                          on: { click: _vm.onRemove },
                                        },
                                        [_vm._v("Delete")]
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "actionLink",
                                          on: { click: _vm.cancelActivity },
                                        },
                                        [_vm._v(" Cancel ")]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1775431310
                        ),
                      }),
                    ],
                    1
                  )
                : !_vm.activity.completed && _vm.activity.drafted
                ? _c(
                    "div",
                    { staticClass: "w-8" },
                    [
                      _c("MoreActions", {
                        staticClass: "relative",
                        attrs: { TooltipBoxStyle: "tooltipTasks" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "action-buttons",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "flex flex-col bg-white" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "actionLink",
                                          on: { click: _vm.onEdit },
                                        },
                                        [_vm._v("Edit Visit")]
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "actionLink",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onPublish(
                                                _vm.activity.id,
                                                _vm.activity
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" Publish ")]
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "actionLink",
                                          on: { click: _vm.onRemove },
                                        },
                                        [_vm._v("Delete")]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          589031385
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm.showNotesModal
          ? _c("NotesModal", {
              attrs: {
                notes: _vm.activity.note,
                currentUser: _vm.currentUser,
                project: _vm.project,
                activity: _vm.activity,
              },
              on: { close: _vm.handleClose },
            })
          : _vm._e(),
        _vm.activityModalOpened
          ? _c("ActivityFormModal", {
              attrs: {
                project: _vm.project,
                projectActivity: _vm.activity,
                currentUserRole: _vm.currentUserRole,
                currentUserId: _vm.currentUserId,
                companyId: _vm.companyId,
              },
              on: {
                activityUpdated: _vm.onActivityUpdated,
                projectsChanged: _vm.onActivityUpdated,
                close: ($event) => (_vm.activityModalOpened = false),
              },
            })
          : _vm._e(),
        _vm.managementTimeTrackerModal
          ? _c("ManagementTimeTrackerModal", {
              attrs: { activity: _vm.activity },
              on: {
                close: () => (_vm.managementTimeTrackerModal = false),
                openDeclineReasonModal: (time) => {
                  _vm.selectedTime = time
                  _vm.managementTimeTrackerModal = false
                  _vm.showDeclineReasonModal = true
                },
              },
            })
          : _vm._e(),
        _vm.showDeclineReasonModal
          ? _c("DeclineReasonModal", {
              staticClass: "z-100",
              attrs: { time: _vm.selectedTime },
              on: {
                closeDeclineModal: () => {
                  _vm.showDeclineReasonModal = false
                  _vm.managementTimeTrackerModal = true
                },
              },
            })
          : _vm._e(),
        _vm.requestedHoursModalOpened
          ? _c("RequestedHours", {
              attrs: {
                activity: _vm.activity,
                confirmedHours: _vm.activity.confirmed_hours,
              },
              on: {
                close: () => (_vm.requestedHoursModalOpened = false),
                openRequestMoreHoursDeclineReasonModal: (time) => {
                  _vm.selectedHours = time
                  _vm.requestedHoursModalOpened = false
                  _vm.requestMoreHoursDeclineReasonModal = true
                },
              },
            })
          : _vm._e(),
        _vm.requestMoreHoursDeclineReasonModal
          ? _c("RequestMoreHoursDeclineReasonModal", {
              attrs: { time: _vm.selectedHours },
              on: {
                closeRequestMoreHoursDeclineModal: () => {
                  _vm.requestMoreHoursDeclineReasonModal = false
                  _vm.requestedHoursModalOpened = true
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }